import { render, staticRenderFns } from "./MemberCenterAdminCreateNotice.vue?vue&type=template&id=a68034a2&lang=pug&"
import script from "./MemberCenterAdminCreateNotice.vue?vue&type=script&lang=js&"
export * from "./MemberCenterAdminCreateNotice.vue?vue&type=script&lang=js&"
import style0 from "./MemberCenterAdminCreateNotice.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports